import { render } from "./reduction_timer.vue?vue&type=template&id=7faf030c"
import script from "./reduction_timer.vue?vue&type=script&lang=js"
export * from "./reduction_timer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/info_block/reduction_timer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7faf030c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7faf030c', __exports__)) {
    console.log('reload')
    api.reload('7faf030c', __exports__)
  }
  
  module.hot.accept("./reduction_timer.vue?vue&type=template&id=7faf030c", () => {
    console.log('re-render')
    api.rerender('7faf030c', render)
  })

}


export default __exports__